import { ABTests, FiverrContext } from '@fiverr-private/fiverr_context';
import { DEFAULT_FIVERR_LOCALE } from '@fiverr-private/localization';
import { EXPERIMENTS } from '@fiverr-private/homepage_common_types';

interface EligibilityProps {
    userId?: number;
    isMobile?: boolean;
    locale: string;
}
export const isEligibleForHighAspJP = ({ userId, isMobile, locale }: EligibilityProps): boolean =>
    Boolean(userId) && !isMobile && locale === DEFAULT_FIVERR_LOCALE;

export const inControl = (experimentId: number, abTests: ABTests = {}): boolean =>
    getAllocation(experimentId, abTests) === 1;

export const inExperiment = (experimentId: number, abTests: ABTests = {}): boolean =>
    getAllocation(experimentId, abTests) > 1;

export const isAllocated = (experimentId: number, abTests: ABTests = {}): boolean =>
    !!getAllocation(experimentId, abTests);

export const getAllocation = (experimentId: number, abTests: ABTests): number => {
    const experimentGroup = abTests[experimentId];

    return Number(experimentGroup);
};

// export const shouldRenderRoutingExperience = (abTests: FiverrContext['abTests']): boolean =>
//     inExperiment(EXPERIMENTS.CHAMS_LYNXES_ROUTING_QUESTIONNAIRE, abTests);

export const shouldRenderJPPrimaryExperience = (abTests: FiverrContext['abTests']): boolean =>
    getAllocation(EXPERIMENTS.CHAMS_DUMMY_SEGMENTATION_JP, abTests) === 2;

export const shouldRenderJPSecondaryExperience = (abTests: FiverrContext['abTests']): boolean =>
    getAllocation(EXPERIMENTS.CHAMS_DUMMY_SEGMENTATION_JP, abTests) === 3;

export const shouldShowHighSpendPotentialJP = (abTests: FiverrContext['abTests']): boolean =>
    inExperiment(EXPERIMENTS.LYNXES_JP_HIGH_SPEND_POTENTIAL, abTests);
